import { axiosClient } from './AxiosClient'

function listRole(page, size, callback, errorCallback){
    let url = "/role/admin/list_by_building"

    axiosClient.get(url, {
        params: {
            building_id: localStorage.getItem('building_id')
        }
    })
    .then((response)=>{
        let data = response.data
        callback(data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function createRole(roleName, roleLevel, callback, errorCallback){
    let url = "/role/admin/create"

    var bodyForm = new FormData()
    bodyForm.append("role_name", roleName)
    bodyForm.append("role_level", roleLevel)
    bodyForm.append("building_id", localStorage.getItem('building_id'))

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        let data = response.data
        callback(data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function updateRole(roleId, roleName, callback, errorCallback){
    let url = "/role/admin/edit"

    var bodyForm = new FormData()
    bodyForm.append("role_id", roleId)
    bodyForm.append("role_name", roleName)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        let data = response.data
        callback(data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function viewRole(roleId, callback, errorCallback){
    let url = "/role/admin/view"

    var bodyForm = new FormData()
    bodyForm.append("role_id", roleId)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        let data = response.data
        callback(data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function deleteRole(roleId, callback, errorCallback){
    let url = "/role/admin/delete"

    var bodyForm = new FormData()
    bodyForm.append("role_id", roleId)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        let data = response.data
        callback(data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function listAccessControl(page, size, callback, errorCallback){
    let url = "/aci/admin/list"

    var bodyForm = new FormData()
    bodyForm.append("page", page)
    bodyForm.append("size", size)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        let data = response.data
        callback(data)
    })
    .catch((error)=>{
        errorCallback(error)
    })

}

function addAccessControl(accessId, roleId, callback, errorCallback){
    let url = "/role/admin/add_item"

    var bodyForm = new FormData()
    bodyForm.append("access_control_item_id", accessId)
    bodyForm.append("role_id", roleId)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        let data = response.data
        callback(data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function removeAccessControl(accessId, roleId, callback, errorCallback){
    let url = "/role/admin/remove_item"

    var bodyForm = new FormData()
    bodyForm.append("access_control_item_id", accessId)
    bodyForm.append("role_id", roleId)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        let data = response.data
        callback(data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

export { 
    listRole, 
    createRole, 
    updateRole, 
    viewRole, 
    deleteRole, 
    listAccessControl, 
    addAccessControl, 
    removeAccessControl,
}